module.exports = __webpack_public_path__ + "img/9.8879be58.svg";